import postAPI from './postAPI.js'

export default async function postTestAction(actionId) {
    const data = await postAPI('admin/taskflows/actions/test', { id: actionId });
    return data;
}
